export default "__VITE_ASSET__B$wQEqK4__"